import subcategoryDetailsSymbols from "../symbols/subcategoryDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function SubcategoryDetailsSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case subcategoryDetailsSymbols.GET_SUBCATEGORY_DETAILS:
      return { ...state, loading: true, error: false };
    case subcategoryDetailsSymbols.GET_SUBCATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case subcategoryDetailsSymbols.GET_SUBCATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case subcategoryDetailsSymbols.CLEAR_GET_SUBCATEGORY_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
